import React from "react";
import { Link } from "react-router-dom";
import { PATHS } from "../routes/paths";
import logo from "../assets/images/admin-login-logo.png";
import "./Maintenance.css";

export default function Maintenance() {
  return (
    <main className="maintenance-page">
      <img className="maintenance-page__logo" src={logo} alt="7 Gerações" />
      <h1>Estamos em manutenção</h1>
      <p className="maintenance-page__message">
        Nosso site está passando por uma atualização e voltará em breve.
      </p>
      <Link className="maintenance-page__login" to={PATHS.login}>
        Acesso administrativo
      </Link>
    </main>
  );
}
